import React from 'react'
import { Flex } from 'antd'
import { MAPPING_GRID_ROW_HEIGHT } from '../../utils/mappingGridTheme'

// Shared wrapper for every Customer/Supplier cell in the wizard grids so that all branches
// (linked / suggestion / skipped / no match) share one floor height and padding. The grids run
// `autoHeight`, so without a common wrapper each branch would auto-measure to a different height
// and rows would jump between ~22px and ~40px.
const WizardGridCell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Flex
    vertical
    justify="center"
    style={{ minHeight: MAPPING_GRID_ROW_HEIGHT, padding: '4px 0', lineHeight: 1.3, fontSize: 12 }}
  >
    {children}
  </Flex>
)

export default WizardGridCell
